<!--
  Implementation

  -in template:
    <date-li  :label="//string"
              :value="//string"
              :keyname="//string"
              :edit="//boolean"
              @fetch="updateValue">
    </date-li>
  
  -import:
    import DateLi from "@/components/ListItems/Editable/DateListItem.vue";

-->

<template>
  <slotted-edit-list-item :label="label"
                          :value="value"
                          :edit="edit"
                          :noempty="noempty"
                          :valuecolor="valuecolor"
                          :overrideDisplayValue="i18nEdit">
    <template v-slot:editmodecontent>
      <v-list-item-content class="pb-0">
        <v-text-field v-model="editValue"
                      ref="datefield"
                      background-color="white"
                      :rules="rule"
                      :label="noempty ? label + '*' : label"
                      hide-details="auto"
                      outlined
                      dense
                      class="field"
                      @focus="$emit('FocusState', true)">
        </v-text-field>
      </v-list-item-content>
      <v-list-item-action class="my-0">
        <v-btn icon
               :class="[$refs['datefield'] && $refs['datefield'].hasError ? 'activeerror': '']"
               class="fieldbutton primary"
               @click="datetrigger++, $emit('FocusState', true)">
          <v-icon size="25"
                  color="#FFFFFF">mdi-calendar</v-icon>
        </v-btn>
      </v-list-item-action>
      <date-picker-dialog :externalTrigger="datetrigger"
                          :onlypast="onlypast"
                          :onlyfuture="onlyfuture"
                          :inDate="vuetifyEdit"
                          @fetch="setEditValue"
                          >
      </date-picker-dialog>
    </template>
  </slotted-edit-list-item>
</template>



<script>
import rules from "@/helpers/Mixins/RuleMixin.js";
import SlottedEditListItem from "@/components/Inputs/Parts/SlottedEditListItem.vue";
import DatePickerDialog from "@/components/Dialogs/DatePickerDialog.vue";

export default {
  name: "EditListItem",
  props: ["label", "keyname", "value", "valuecolor", "edit", "noempty", "onlyedit", "onlypast", "onlyfuture", "loading"],
  components: { SlottedEditListItem, DatePickerDialog },
  mixins: [rules],

  data() {
    return {
      editValue: null,
      datetrigger: 0,
    };
  },

  mounted() {
    this.parseDate(this.value);
    this.emitValue();
  },

  methods: {
    setEditValue(newval) {
      this.parseDate(newval);
    },
    emitValue() {
      this.$emit("fetch", { key: this.keyname, value: this.oldFormatDate(this.editValue) });
    },

    parseDate(val) {
      this.editValue = this.i18nFormatDate(val);
    },
  },

  computed: {
    rule() {
      if (this.noempty) {
        return this.noEmptyRule;
      } else {
        return [];
      }
    },

    i18nEdit() {
      var val = this.i18nFormatDate(this.editValue);
      return val ? val : "Invalid or no date set";
    },

    vuetifyEdit() {
      return this.VuetifyFormatDate(this.editValue);
    },
  },

  watch: {
    value: function () {
      this.parseDate(this.value);
    },

    editValue: function () {
      this.emitValue();
    },
  },
};
</script>

<style lang="scss" scoped>
.error--text {
  margin-bottom: -8px !important;
}
.field {
  background-color: transparent;
  z-index: 5;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.fieldbutton {
  height: 40px !important;
  border: 1px solid rgba($color: #000000, $alpha: 0.1);
  border-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 19px !important;
  padding-left: 28px !important;
  margin-left: -10px;
  margin-top: 12px;
  z-index: 1;
}
.fieldbutton.activeerror {
  margin-top: -7px;
}
.fieldbutton:hover {
  border: 1px solid rgb(55, 55, 55);
}
</style>